var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavSubscription = function SvgNavSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#8FB4EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#NavSubscription_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 18.05v3.02a7 7 0 1 0 5.192 12.536l2.137 2.137A9.966 9.966 0 0 1 28 38c-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95ZM37.95 29a9.948 9.948 0 0 1-2.207 5.328l-2.137-2.136A6.958 6.958 0 0 0 34.929 29h3.022-.001Zm-8.948-10.95a10.004 10.004 0 0 1 8.95 8.95H34.93a7.005 7.005 0 0 0-5.928-5.929v-3.022.001Z",
    fill: "#247BFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "NavSubscription_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16 16)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgNavSubscription;